<template>
    <div class="lsn-cancelable-toast__container">
        <div>
            {{ runningLabel }}
        </div>

        <button class="lsn-cancelable-toast__btn" @click.stop="cancel">
            {{ cancelLabel }}
        </button>
    </div>
</template>

<script setup>
import { onBeforeUnmount, ref } from 'vue';

const props = defineProps({
    runningLabel:
    {
        type:     String,
        required: true,
    },

    cancelLabel:
    {
        type:     String,
        required: true,
    },
});

const wasCanceled = ref(false);

const emit = defineEmits(['cancel', 'submit']);

function cancel()
{
    wasCanceled.value = true;
    emit('cancel');
}

onBeforeUnmount(() =>
{
    if(!wasCanceled.value)
    {
        emit('submit');
    }
});
</script>

<style scoped>
@reference "#main.css";

.lsn-cancelable-toast__container
{
    @apply flex justify-between items-center gap-4;
}

.lsn-cancelable-toast__btn
{
    @apply rounded border-white/60 px-4 py-2 bg-black/30 text-white transition
        hover:bg-white/30;
}
</style>
